import { render, staticRenderFns } from "./ConfiguratorSettingsForm.vue?vue&type=template&id=1ff18435&"
import script from "./ConfiguratorSettingsForm.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports